﻿import * as React from 'react';
import styles from './style.module.scss';
import { SvgAnnotations, useAnnotationsListener } from './svg-annotations';

export const SvgAnnotationsWindow = () => {
    useAnnotationsListener();

    return (
        <div className={`${styles.annotationsWindow} ${SvgAnnotations.textAnnotations.length == 0 && styles.annotationsWindowHidden}`}>
            <ul>
                {SvgAnnotations.textAnnotations.map(line => {
                    let key: string;
                    if (typeof line === 'string') {
                        key = line;
                    } else if (line.key && line.key.toString().length > 0) {
                        key = line.key.toString();
                    } else {
                        key = line.toString();
                    }

                    return (
                        <li key={key}>{line}</li>
                    );
                })}
            </ul>
        </div>
    );
}
